import { WIDGET_CONFIG } from '../config'

interface TriggerBarProps {
  label?: string
  onOpen: () => void
  position?: 'bottom-center' | 'bottom-right' | 'bottom-left' | 'top-center' | 'top-right' | 'top-left'
}

export function TriggerBar({ label = WIDGET_CONFIG.copy.triggerLabel, onOpen, position = 'bottom-center' }: TriggerBarProps) {
  const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform)
  const modKey = isMac ? '⌘' : 'Ctrl'
  const posClass = position !== 'bottom-center' ? ` spotlight-trigger--${position}` : ''

  return (
    <div class={`spotlight-trigger${posClass}`} onClick={onOpen} role="button" aria-label="Open search">
      <svg class="spotlight-search-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <span class="spotlight-trigger-label">{label}</span>
      <span class="spotlight-trigger-kbd">
        <span>{modKey}</span>
        <span>K</span>
      </span>
    </div>
  )
}
